import { Typography } from "antd"
import cx from "clsx"
import { useCallback } from "react"
import PropTypes from "prop-types"
import { SkeletonWrapper } from "components/common"
import styles from "./index.module.less"

const { Text: AntdText } = Typography

const Text = props => {
  const { 
    children, 
    block = false, 
    className, 
    style, 
    loading = false, 
    loadingProps = {},
    ...rest 
  } = props

  // Default loading props for Text component
  const defaultLoadingProps = {
    width: "100%",
    height: 16,
    round: true,
    ...loadingProps
  }

  const textContent = (
    <AntdText
      className={cx(styles.typography, rest.type && styles[`ant-typography-${rest.type}`], className)}
      style={{ "--typography-color": rest.color, ...style }}
      {...rest}
    >
      {children}
    </AntdText>
  )

  return (
    <SkeletonWrapper 
      loading={loading} 
      {...defaultLoadingProps}
    >
      {block ? <div>{textContent}</div> : textContent}
    </SkeletonWrapper>
  )
}

Text.propTypes = {
  children: PropTypes.node,
  block: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  loading: PropTypes.bool,
  loadingProps: PropTypes.object,
  type: PropTypes.string,
  color: PropTypes.string,
}

Text.defaultProps = {
  block: false,
  loading: false,
  loadingProps: {},
}

export default Text
